module.exports = __webpack_public_path__ + "static/media/06_CALCINHA_FIO_DUPLO_LISA_06.98edad9c.jpg";